import { CustomEventNames, logLoyaltyEvent } from 'state/amplitude';
import { AppOfferListItem } from 'state/loyalty/types';

import { buildOffersDisplayedAnalytics } from './offers-displayed';

export function logOffersDisplayed(offerListItems: AppOfferListItem[]) {
  const { standaloneOffers, attributes } = buildOffersDisplayedAnalytics(offerListItems);

  logLoyaltyEvent(
    {
      name: CustomEventNames.OFFERS_DISPLAYED,
      incentives: standaloneOffers,
      attributes,
    },
    { skipLoggingToBraze: true }
  );
}
